import { alpha } from '@mui/material/styles';

export const createGlimmerButtonSx = ({
  animationName,
  duration = 3.7,
  marginTop,
  withDisabledStyles = false,
} = {}) => ({
  ...(marginTop !== undefined ? { marginTop } : {}),
  color: '#ffffff',
  backgroundColor: 'accent.main',
  borderColor: 'accent.main',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    backgroundColor: 'accent.dark',
    borderColor: 'accent.dark',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: -2,
    left: -130,
    width: '34%',
    height: 'calc(100% + 4px)',
    transform: 'skewX(-22deg)',
    background:
      'linear-gradient(110deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 34%, rgba(255,255,255,0.72) 50%, rgba(255,255,255,0.08) 66%, rgba(255,255,255,0) 100%)',
    pointerEvents: 'none',
    animation: `${animationName} ${duration}s ease-in-out infinite`,
  },
  [`@keyframes ${animationName}`]: {
    '0%': { left: '-130%', opacity: 0 },
    '8%': { opacity: 1 },
    '24%': { left: '142%', opacity: 0 },
    '100%': { left: '142%', opacity: 0 },
  },
  ...(withDisabledStyles
    ? {
        '&.Mui-disabled': {
          backgroundColor: (theme) => alpha(theme.palette.accent.main, 0.45),
          color: (theme) => alpha(theme.palette.common.white, 0.82),
        },
        '&.Mui-disabled::after': {
          display: 'none',
        },
      }
    : {}),
});
